import { Component, type ErrorInfo, type ReactNode } from 'react';
import i18n from '../i18n';

/**
 * The last net under the app: a render that throws (a date no formatter can
 * read, a shape the server never sent before) shows a way back instead of a
 * blank page. Data fetching has its own error states; this is for the rest.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  override state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error): { error: Error } {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Unhandled render error', error, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.error) return this.props.children;
    return (
      <main role="alert" className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-(--color-canvas) px-6 text-center">
        <h1 className="font-display text-xl text-(--color-ink-900)">{i18n.t('errorPage.title')}</h1>
        <p className="max-w-md text-sm text-(--color-ink-500)">
          {i18n.t('errorPage.body')}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-lg bg-(--color-accent) px-4 py-2 text-sm font-semibold text-white hover:opacity-90"
        >
          {i18n.t('errorPage.reload')}
        </button>
      </main>
    );
  }
}
